import { render, staticRenderFns } from "./QuestionPostBody.vue?vue&type=template&id=ee274a56&scoped=true&"
import script from "./QuestionPostBody.vue?vue&type=script&lang=js&"
export * from "./QuestionPostBody.vue?vue&type=script&lang=js&"
import style0 from "./QuestionPostBody.vue?vue&type=style&index=0&id=ee274a56&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee274a56",
  null
  
)

export default component.exports